'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeSearchFormModal = undefined;

var _setup = require('./setup.js');

// search form modal
var $modalParts = _setup.s.$searchModal.find('label, input, .nx-searchbar--close');
var $modalShade = $('<div id="nx-overlay-shade" class="nx-overlay nx-overlay--shade"></div>');

var listHeight = null;

var onOpenComplete = function onOpenComplete() {
  _setup.s.$searchInput.focus();
  listHeight = _setup.s.$window.height() - (_setup.s.$searchAutoForm.offset().top + _setup.s.$searchAutoForm.height());
  _setup.s.$searchAutoList.css({ maxHeight: listHeight + 'px' });
};

var openSearchFormModal = function openSearchFormModal() {
  _setup.s.$body.addClass('is-showing-searchmodal').append($modalShade);

  TweenMax.set($modalShade, { autoAlpha: 0 });
  TweenMax.fromTo(_setup.s.$searchModal, 0.35, { autoAlpha: 1, y: '-100%' }, { autoAlpha: 1, y: '0%', ease: Expo.easeOut });
  TweenMax.to($modalShade, 0.2, { autoAlpha: 1 });
  TweenMax.staggerFromTo($modalParts, 0.75, { autoAlpha: 0, y: -10 }, { autoAlpha: 1, y: 0, delay: 0.1, ease: Expo.easeOut, onComplete: onOpenComplete }, 0.15);

  _setup._s.searchOverlayShowing = true;
};

var closeSearchFormModal = exports.closeSearchFormModal = function closeSearchFormModal() {
  _setup.s.$body.removeClass('is-showing-searchmodal');

  TweenMax.to(_setup.s.$searchModal, 0.15, { autoAlpha: 0, y: '-100%' });
  TweenMax.to($modalShade, 0.15, { autoAlpha: 0, onComplete: function onComplete() {
      return $modalShade.detach();
    } });

  _setup._s.searchOverlayShowing = false;
};

var doSearchFormModal = function doSearchFormModal(event) {
  event.preventDefault();
  if (TweenMax.isTweening(_setup.s.$searchModal)) return;

  //focus input on actual search page, or if modal is open already
  if (_setup.s.$searchModal.length === 0) {
    _setup.s.$searchInput.focus();
    return;
  }

  if (_setup._s.searchOverlayShowing) {
    closeSearchFormModal();
  } else {
    openSearchFormModal();
  }
};

if (_setup.s.$searchBtn.length) {
  _setup.s.$searchBtn.on('click', doSearchFormModal);
}
if (_setup.s.$searchClose.length) {
  $modalShade.on('click', closeSearchFormModal);
  _setup.s.$searchClose.on('click', closeSearchFormModal);
}

// Search Autocomplete

var currentXHR = null;
var searchTerm = null;
var lastTerm = null;

//single result list item
var getListItemHtml = function getListItemHtml(item) {
  var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


  var modClass = last ? ' is-last-row' : '';
  var getSku = function getSku() {
    return item.type === 'product' ? '<small>' + item.sku + '</small>' : '';
  };
  var getTags = function getTags() {
    if (item.type === 'article' && item.blog_type === 'recipes') {
      return '<small>' + item.article_tags + ' Recipe</small>';
    } else if (item.type === 'article' && item.blog_type === 'stories') {
      return '<small>' + item.article_tags + '</small>';
    } else {
      return '';
    }
  };

  var html = '<li class="nx-searchresults--row' + modClass + '">';
  if (last) {
    html += '<a href="/search?q=' + searchTerm + '">View All Results for "<span>' + searchTerm + '</span>" (' + last + ') <i class="icon-right-dir"></i></a>';
  } else {
    html += '<div class="nx-searchrow--thumb">\n              <figure>\n                <img src="' + item.thumbnail + '" alt="' + item.title + '" />\n              </figure>\n            </div>\n            <div class="nx-searchrow--info">\n              ' + getTags() + '\n              <h4><a href="' + item.url + '">' + item.title + '</a></h4>\n              ' + getSku() + '\n            </div>\n            <div class="nx-searchrow--links">\n              <a href="' + item.url + '" class="nx-btn nx-btn--primary">View ' + item.btn_text + '</a>\n            </div>';
  }
  html += '</li>';
  return html;
};

var onXhrDone = function onXhrDone(data) {
  console.log(data);

  if (data.results_count === 0) {
    _setup.s.$searchModal.removeClass('has-autocomplete-results');
    _setup.s.$searchAutoList.html('<p>No results found for "<span>' + searchTerm + '</span>".</p>');
    return;
  }
  _setup.s.$searchModal.addClass('has-autocomplete-results');

  var html = '<ul>';
  $.each(data.results, function (index, item) {
    html += getListItemHtml(item);
  });
  if (data.results_count > data.results.length) {
    html += getListItemHtml(null, data.results_count);
  }
  html += '<ul>';

  _setup.s.$searchAutoList.html(html);
};

var onXhrFail = function onXhrFail() {};

var doAutocompleteSearch = function doAutocompleteSearch() {
  searchTerm = _setup.s.$searchInput.val();

  console.log(lastTerm);
  console.log(searchTerm);

  _setup.s.$searchAutoList.html('');

  if (currentXHR != null) {
    currentXHR.abort();
  }

  if (searchTerm.length > 3 && searchTerm !== lastTerm) {
    lastTerm = searchTerm;
    currentXHR = $.getJSON('/search?q=' + searchTerm + '&view=json');
    currentXHR.done(onXhrDone);
    currentXHR.fail(onXhrFail);
  } else {}
};

//only if search modal input exists
if (_setup.s.$searchAutoForm.length) {
  _setup.s.$searchInput.on('input', doAutocompleteSearch);
}


//////////////////
// WEBPACK FOOTER
// ./_js/search.js
// module id = 18
// module chunks = 0